import { render } from "./ReceiptProductCard.vue?vue&type=template&id=d83a14fc"
import script from "./ReceiptProductCard.vue?vue&type=script&lang=js"
export * from "./ReceiptProductCard.vue?vue&type=script&lang=js"

import exportComponent from "E:\\Proj\\Apps\\takht-jamshid\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__